import { makeStyles } from '@material-ui/core/styles'
import { transition } from '../style-settings'
import { createStyles, Theme } from '@material-ui/core'

export const useFilterCommonStyles = makeStyles((theme: Theme) =>
  createStyles({
    filterHolder: {
      position: 'relative',
      width: '100%',
      borderRadius: theme.shape.borderRadius * 2,
      border: `1px solid ${theme.palette.divider}`,
      overflow: 'hidden',
      boxSizing: 'border-box',
      '&  .MuiCardContent-root:last-child': {
        paddingBottom: theme.spacing(2),
      },
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 40,
        height: 40,
        minHeight: 40,
        padding: 0,
        borderRadius: theme.shape.borderRadius * 2,
      },
    },
    closeBtn: {
      cursor: 'pointer',
      position: 'absolute',
      top: theme.spacing(1),
      right: theme.spacing(1),
      padding: theme.spacing(0),
      borderRadius: '50%',
      transition: transition,
      zIndex: 1,
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
        transform: 'rotate(90deg)',
      },
    },
    filterBody: {
      position: 'relative',
      padding: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(1),
      },
    },
    filterWrapper: {
      width: '100%',
      maxWidth: '100%',
      boxSizing: 'border-box',
    },
    drawerPaper: {
      width: `min(calc(100vw - ${theme.spacing(2)}px), ${theme.spacing(40)}px)`,
      maxWidth: theme.spacing(40),
      boxSizing: 'border-box',
    },
    checkboxHolder: {
      marginBottom: theme.spacing(1.5),
      textAlign: 'left',
      '& .MuiFormControlLabel-root': {
        marginRight: 0,
        marginLeft: 0,
      },
    },
    rangeHolder: {
      marginBottom: theme.spacing(1.5),
    },
    slider: {
      marginBottom: theme.spacing(1.5),
      marginTop: theme.spacing(0.75),
    },
    inputPriceBlock: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(1),
      gap: theme.spacing(1),
    },
    priceTitle: {
      textAlign: 'left',
      fontWeight: 600,
      marginBottom: theme.spacing(0.75),
      color: theme.palette.text.primary,
      fontSize: '0.9375rem',
    },
    priceInput: {
      maxWidth: '100%',
    },
    lookupHolderCategory: {
      marginBottom: theme.spacing(1.5),
    },
    lookupHolderNonprofit: {
      marginBottom: theme.spacing(1.5),
    },
    searchTextHolder: {
      marginBottom: theme.spacing(1.5),
    },
    searchTextHolderMobile: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1.5),
    },
    buttonContainer: {
      marginTop: theme.spacing(1.5),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.75),
      '& .MuiButton-root': {
        borderRadius: theme.shape.borderRadius,
        textTransform: 'none',
        fontWeight: 600,
        padding: theme.spacing(1.25, 2),
      },
    },
    sectionDivider: {
      margin: theme.spacing(1.5, 0),
      borderTop: `1px solid ${theme.palette.divider}`,
    },
  })
)
